import React from 'react';
import CorePage from '../../views/core/CorePage';

// ES6 class-style
class SubscribeButton extends CorePage {
    
 getGa(){
     if(this.props.ga && typeof this.props.ga === "string"){
        return this.props.ga;
     }else if(this.props.ga && typeof this.props.ga === "object" && this.props.ga["subscribe-btn"]){
         return this.props.ga["subscribe-btn"];
     }else{
         return "Post login - Subscribe";
     }
 }

  render() {
    return(
            <span id="SubscribeButton" className="float-right">
                <span className="btn btn-primary largeBtn subscribe_style" onClick={()=>{
                    window.location.href="/myproducts";
                }}>{this.rb("product.buynow")}</span>      
            </span>
          )
  }
}

export default SubscribeButton;



// WEBPACK FOOTER //
// ./src/views/common/SubscribeButton.js